import { DashboardV2ApiClient } from '@fourthwall/services/dist/DashboardV2ApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useDashboardStatisticsQuery = createQueryHook(
  DashboardV2ApiClient.getDashboardStatistics,
  {
    queryKey: ['dashboardStatistics'],
  },
)
